import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import accountDataAccess from "src/dataAccess/account/accountDataAccess";
import Modal from "src/microComponent/ModalHandlers/GenericModal";
import { LoaderModal } from "src/microComponent/ModalHandlers/LoaderModal";
import { localStorageKeys } from "src/common/constants";
import { applyOrgTheme } from "src/Layout/applyOrgTheme";

export const logoutPage = createAction<boolean>(
  "[Account] Logout success page start"
);

export const logoutUserSuccess = createAction<boolean>(
  "[Account] Logout user success"
);

export const logoutUser = createAsyncThunk(
  "[Account] Logout user",
  async (parameter, thunkAPI) => {
    let ref = Modal.openModal({
      componentNonNode: LoaderModal,
      data: "Logging out ...",
      maskClosable: false,
    });

    const clearUserDataOnly = () => {
      // Preserve theme before clearing
      const savedTheme = localStorage.getItem("Theme");

      // Clear all localStorage
      localStorage.clear();

      // Restore theme if it existed and reapply it
      if (savedTheme) {
        localStorage.setItem("Theme", savedTheme);
        // Reapply the theme to the DOM
        if (savedTheme === "default") {
          applyOrgTheme(null);
        } else {
          applyOrgTheme(parseInt(savedTheme));
        }
      } else {
        // If no theme was saved, apply default theme
        applyOrgTheme(null);
      }
    };

    const result = await accountDataAccess
      .sigout()
      .then((res) => {
        clearUserDataOnly();
        thunkAPI.dispatch(logoutPage(true));
        thunkAPI.dispatch(logoutUserSuccess(true));
        ref.destroy();
        return res;
      })
      .catch((error) => {
        clearUserDataOnly();
        thunkAPI.dispatch(logoutPage(true));
        thunkAPI.dispatch(logoutUserSuccess(true));
        ref.destroy();
        return error;
      });
    return result;
  }
);

export const loginUserSuccess = createAction<any>(
  "[Account] Login user success"
);
